const stringsComuns = require('./comum');

module.exports = {
    adicionar: stringsComuns.adicionar,
    agendado: 'Agendado',
    alterar: stringsComuns.alterar,
    alterarMeusDados: stringsComuns.alterarMeusDados,
    altura: stringsComuns.altura,
    ambienteDestino: 'Ambiente de Destino',
    anosFuma: stringsComuns.anosFuma,
    anosRetorno: 'Anos para o retorno:',
    anterior: stringsComuns.anterior,
    apresentacao: 'Apresentação',
    assinaleLocaisLesoes: 'Assinale o(s) local(is) da(s) lesão(ões)',
    assinando: 'Aguarde - assinando digitalmente o laudo...',
    ate: stringsComuns.dataAte,
    atencao: stringsComuns.atencao,
    atendimentoRegistrado: 'Atendimento registrado',
    atendimentoRegistrado: 'Dados do atendimento ao paciente registrados',
    ausente: 'Ausente',
    avaliacao: 'Avaliação',
    avaliacaoRegistrada: 'Avaliação registrada',
    avaliar: 'Avaliar',
    bairro: 'Bairro',
    BRACO_DIREITO_ANTERIOR: 'BRACO_DIREITO_ANTERIOR',
    BRACO_DIREITO_POSTERIOR: 'BRACO_DIREITO_POSTERIOR',
    BRACO_ESQUERDO_ANTERIOR: 'BRACO_ESQUERDO_ANTERIOR',
    BRACO_ESQUERDO_POSTERIOR: 'BRACO_ESQUERDO_POSTERIOR',
    buscar: stringsComuns.buscar,
    C: 'Câncer da pele',
    cabeca: 'Cabeça',
    CABECA: 'CABECA',
    cadastrar: 'Cadastrar',
    campoObrigatorio: stringsComuns.campoObrigatorio,
    cancelar: stringsComuns.cancelar,
    cancelar: stringsComuns.cancelar,
    CANCER_PELE: 'C',
    cancerPele: 'Câncer de pele',
    carregandoExame: 'Carregando exame',
    categoria: 'Categoria',
    cbc: 'Carcinoma Basocelular (CBC)',
    cec: 'Carcinoma Espinocelular (CEC)',
    cid10: stringsComuns.cid10,
    cidadeProcedencia: stringsComuns.cidadeProcedencia,
    cigarrosDia: stringsComuns.cigarrosDia,
    classificacaoRisco: 'Classificação de risco',
    classificacaoRiscoObrigatoria: stringsComuns.campoObrigatorio,
    classRiscoDermatose: 'Classificação de risco e Dermatose',
    cns: stringsComuns.cns,
    coloracao: 'Coloração',
    coloracaoObrigatoria: stringsComuns.campoObrigatorio,
    comLaudo: stringsComuns.comLaudo,
    comorbidades: stringsComuns.comorbidades,
    conclusao: 'Conclusão',
    concordoP: 'Concordo parcialmente',
    concordoT: 'Concordo totalmente',
    conexaoRestabelecida: 'Conexão restabelecida',
    confirmando: 'Confirmando laudo',
    confirmar: stringsComuns.confirmar,
    confirmarInvalidarExame: stringsComuns.confirmarInvalidarExame,
    confirmarPriorizarExame: stringsComuns.confirmarPriorizarExame,
    confirmarRemoverCid10: 'Você confirma a exclusão do CID-10?',
    confirmarRemoverLesao: 'Você confirma a exclusão da lesão?',
    contato: stringsComuns.contato,
    contatoDermatoscopia: 'Dermatoscopia',
    contraRefercia: 'Contra-referência',
    copiarLaudo: 'Copiar laudo',
    copiarLaudoInfo: 'Os dados preechidos em "Lesão elementar", "Lesão secundária", "Coloração", "Morfologia", "Distribuição", "Tamanho", "Compatibilidade", "Classificação de risco", "Grupo dermatose" e "Dermatose" serão copiados para a lesão informada.',
    copiarPara: 'Copiar para:',
    corpoAnterior: 'Corpo anterior',
    corpoPosterior: 'Corpo posterior',
    dadosCopiados: 'Dados copiados',
    dadosExame: stringsComuns.dadosExame,
    dadosInvalidos: 'Dados inválidos. Verifique os dados informados e tente novamente.',
    dadosPaciente: stringsComuns.dadosPaciente,
    data: stringsComuns.data,
    dataExame: stringsComuns.dataExame,
    dataFinalExame: stringsComuns.dataFinalExame,
    dataFinalInvalidacao: stringsComuns.dataFinalInvalidacao,
    dataFinalLaudo: stringsComuns.dataFinalLaudo,
    dataFinalSolicitacao: stringsComuns.dataFinalSolicitacao,
    dataHoraAtendimento: 'Data/hora do atendimento',
    dataInicialExame: stringsComuns.dataInicialExame,
    dataInicialInvalidacao: stringsComuns.dataInicialInvalidacao,
    dataInicialLaudo: stringsComuns.dataInicialLaudo,
    dataInicialSolicitacao: stringsComuns.dataInicialSolicitacao,
    dataInvalida: stringsComuns.dataInvalida,
    dataLaudo: stringsComuns.dataLaudo,
    dataNascimento: stringsComuns.dataNascimento,
    dataNascimentoFutura: stringsComuns.erroDataFutura,
    dataNascimentoInvalida: stringsComuns.dataInvalida,
    dataSolicitacao: stringsComuns.dataSolicitacao,
    de: stringsComuns.de,
    Dermacritic: {
        'no ruler present': 'Régua não detectada.',
        'no tag present': 'Etiqueta não detectada.',
        'not all body parts are visible': 'Nem todas as partes do corpo estão visíveis.',
        'nothing detected or impossible to detect: Verify the captured image': 'Não foi possível detectar a etiqueta e/ou régua.',
        'nothing detected or tag is too small to detect: Verify the captured image': 'A etiqueta é muito pequena para ser detectada.',
        'orientation detected is different. Expected: Anterior, Found: P': 'A orientação detectada é diferente. Esperada: anterior. Encontrada: posterior.',
        'orientation detected is different. Expected: Posterior, Found: A': 'A orientação dectada é diferente. Esperada: posterior. Encontrada: anterior.'
    },
    dermatose: 'Dermatose',
    dermatoseObrigatoria: stringsComuns.campoObrigatorio,
    descricaoEstudo: 'Descrição do estudo',
    descricaoEstudoObrigatorio: stringsComuns.campoObrigatorio,
    descricaoExame: 'Descrição do exame',
    descritores: 'Descritores',
    diasRetorno: 'Dias para o retorno:',
    diminuida: 'Diminuída',
    direcionados: 'Direcionado ao meu usuário',
    discordoP: 'Discordo parcialmente',
    discordoT: 'Discordo totalmente',
    distribuicao: 'Distribuição',
    distribuicaoObrigatoria: stringsComuns.campoObrigatorio,
    documentosImpressos: 'Selecione os documentos a serem impressos.',
    documentosImpressosF: 'Formulário médico para solicitação de medicamento(s)',
    documentosImpressosL: '(LME) Laudo de solicitação, avaliação e autorização de medicamento(s)',
    documentosImpressosR: 'Receita do(s) medicamento(s)',
    documentosImpressosT: 'Termo de esclarecimento e responsabilidade',
    duasQuatroVezezMes: '2-4 vezes ao mês',
    duasTresVezesSemana: '2-3 vezes por semana',
    emailInvalido: 'Email inválido',
    enviar: 'Enviar',
    enviarImagens: stringsComuns.enviarImagens,
    envioImagens: stringsComuns.envioImagens,
    equipamento: stringsComuns.equipamento,
    equipamentoObrigatorio: stringsComuns.campoObrigatorio,
    erro: stringsComuns.erro,
    erroAssinatura: 'Erro ao assinar digitalmente o laudo',
    erroDataFutura: stringsComuns.erroDataFutura,
    erroDataMenorDataInicio: stringsComuns.erroDataMenorDataInicio,
    erroDesconhecido: stringsComuns.mensagemErroGeral,
    erroGerarProtocoloEnvioExame: stringsComuns.erroGerarProtocoloEnvioExame,
    erroGerarTermo: stringsComuns.erroGerarTermo,
    erroIgnorarExame: stringsComuns.erroIgnorarExame,
    erroInvalidarExame: stringsComuns.erroInvalidarExame,
    erroPriorizarExame: stringsComuns.erroPriorizarExame,
    erroSortearExame: 'Não foi possível sortear o próximo exame para laudo. Tente novamente e se o problema persistir, entre em contato com os administradores.',
    erroTrocarRedeExame: stringsComuns.erroTrocarRedeExame,
    especificacaoTempo: 'Especificação',
    esposicaoSolHorasDiaObrigatorio: stringsComuns.campoObrigatorio,
    etilismo: stringsComuns.etilismo,
    etilismoFrequencia: 'Etilismo - com qual frequência consome bebidas com álcool?',
    etilismoObrigatorio: stringsComuns.campoObrigatorio,
    exameInvalidado: stringsComuns.exameInvalidado,
    exameMaisAntigoSemLaudo: 'Data do exame mais antigo sem laudo',
    exameNumero: 'Exame nº',
    examePriorizado: stringsComuns.examePriorizado,
    exameRegistrado: stringsComuns.exameRegistrado,
    exames: stringsComuns.exames,
    examesAgendados: 'Agendados',
    examesComImagens: 'Com imagens',
    examesComLaudo: stringsComuns.examesComLaudo,
    exameSelecionado: 'Exame selecionado',
    examesInvalidos: 'Inválidos',
    examesInvalidos: stringsComuns.examesInvalidos,
    examesPacs: 'PACS',
    examesSelecionados: 'Exames selecionados',
    examesValidos: 'Válidos',
    examesValidos: stringsComuns.examesValidos,
    excluir: stringsComuns.excluir,
    exFumante: 'Ex-fumante',
    exposicaoSol: 'Exposição ao sol',
    exposicaoSolHorasDia: 'Exposição ao sol (h/dia)',
    exposicaoSolMesesAno: 'Exposição ao sol (meses/ano)',
    exposicaoSolMesesAnoObrigatorio: stringsComuns.campoObrigatorio,
    fechar: stringsComuns.fechar,
    finalizar: stringsComuns.finalizar,
    formularioSolicitacaoMed: 'Formulário de solicitação de medicamentos',
    fotoprotetor: 'Fotoprotetor',
    fotoprotetorEspecificacaoObrigatorio: stringsComuns.campoObrigatorio,
    fotoprotetorFrequenciaDiaria: 'Fotoprotetor (frequência diária)',
    fotoprotetorFrequenciaObrigatorio: stringsComuns.campoObrigatorio,
    fotoprotetorPeriodo: 'Tempo de uso',
    fotoprotetorTempoUso: 'Fotoprotetor (tempo de uso)',
    fototipo: 'Fototipo',
    fototipoObrigatorio: stringsComuns.campoObrigatorio,
    frequencia: 'Frequência',
    frequenciaDiaria: 'Frequência diária',
    fumante: 'Fumante',
    genero: stringsComuns.genero,
    gerandoDocumento: stringsComuns.gerandoDocumento,
    gerandoNumeroProtocolo: stringsComuns.gerandoNumeroProtocolo,
    gerandoResumo: 'Gerando resumo do laudo',
    gerandoTCLE: stringsComuns.gerandoTCLE,
    grupoDermatose: 'Grupo dermatose',
    grupoDermatoseObrigatorio: stringsComuns.campoObrigatorio,
    hmf: 'História mórbida familiar (HMF)',
    hmp: 'História mórbida pregressa (HMP)',
    hmpc: 'História mórbida pregressa (HMP) - Pele',
    hmpCancerPeleObrigatoria: stringsComuns.campoObrigatorio,
    hmpo: 'História mórbida pregressa (HMP) - Outros',
    hmpOutroCancerObrigatoria: stringsComuns.campoObrigatorio,
    idade: stringsComuns.idade,
    ignorandoExame: 'Ignorando exame',
    imagemInvalida: 'O campo deve conter uma imagem do tipo JPG',
    imagemLesao: 'Imagem da lesão',
    imagemLesaoObrigatoria: stringsComuns.campoObrigatorio,
    imagensGerais: 'Imagens gerais',
    imprimir: stringsComuns.imprimir,
    imprimirProtocolo: stringsComuns.imprimirProtocolo,
    imprimirTermo: stringsComuns.imprimirTermo,
    indicacaoClinica: stringsComuns.indicacaoClinica,
    infeccoes: stringsComuns.infeccoes,
    infoClinicas: 'Informações clínicas',
    infoComplementares: 'Informações complementares',
    informacoesGerais: 'Informações gerais',
    inicio: stringsComuns.inicio,
    instituicao: stringsComuns.instituicao,
    instituicaoObrigatoria: stringsComuns.campoObrigatorio,
    instituicaoSolicitante: 'Instituição solicitante',
    invalidandoExame: stringsComuns.invalidandoExame,
    invalidar: stringsComuns.invalidar,
    invalido: 'Inválido',
    justificativa: 'Justificativa',
    laudo: stringsComuns.laudo,
    laudoAguardandoComplemento: stringsComuns.laudoAguardandoComplemento,
    laudoAssinado: 'Laudo assinado digitalmente com sucesso',
    laudoEmEmissao: 'Devido à demora na emissão do laudo, este exame foi acessado por outro profissional. O próximo exame será carregado.',
    laudoEmissao: stringsComuns.laudoEmissao,
    laudoEmitidoExame: 'Laudo emitido para o exame',
    laudosEmitidos: 'Laudos emitidos',
    laudosGraves: 'Laudos graves',
    laudoTemporario: stringsComuns.laudoTemporario,
    laudoTextual: 'Laudo textual',
    lesao: 'Lesão',
    lesaoCompativelCom: 'Lesão Compatível com',
    lesaoCompativelComObrigatoria: stringsComuns.campoObrigatorio,
    lesaoElementar: 'Lesão elementar',
    lesaoElementarObrigatoria: stringsComuns.campoObrigatorio,
    lesaoObrigatoria: 'Pelo menos uma lesão deve ser informada',
    lesaoSecundaria: 'Lesão secundária',
    lesaoSecundariaObrigatoria: stringsComuns.campoObrigatorio,
    lesoes: 'Lesões',
    limpar: stringsComuns.limpar,
    linhasPorPagina: stringsComuns.linhasPorPagina,
    local: 'Local',
    localizacao: 'Localização',
    localizacaoObrigatoria: stringsComuns.campoObrigatorio,
    logout: 'Você foi desconectado do sistema',
    logradouro: 'Logradouro',
    materiaisSuporte: stringsComuns.materiaisSuporte,
    medicamento: 'Medicamento',
    medicamentosAdicionados: 'Medicamentos adicionados',
    medicoExecutor: 'Médico executor',
    medicoSolicitante: stringsComuns.medicoSolicitante,
    medSistemico: 'Medicamentos de uso sistêmico.',
    medTopico: 'Medicamentos de uso tópico.',
    melanoma: 'Melanoma',
    membrosInferioresAnterior: 'Membros inferiores - anterior',
    membrosInferioresPosterior: 'Membros inferiores - posterior',
    membrosSuperioresAnterior: 'Membros superiores - anterior',
    membrosSuperioresPosterior: 'Membros superiores - posterior',
    mensagemAlertaCancelamento: 'Você confirma o cancelamento do envio de imagens?',
    mensagemConfirmarEnvioExame: 'Deseja enviar as fotos das lesões agora?',
    mensagemConfirmarTermo: 'Deseja imprimir o TCLE?',
    mensagemConfirmarTermo_solicitacao: stringsComuns.mensagemConfirmarTermo_solicitacao,
    mensagemDermatoscopia: 'É possível que o dermatologista solicite a realização do registro fotográfico de contato (dermatoscopia) para esta lesão. Caso isso ocorra, o paciente deve ser encaminhado para o setor que realiza a Teledermatoscopia em sua região.',
    mensagemEnviandoImagens: stringsComuns.mensagemEnviandoImagens,
    mensagemErro: stringsComuns.mensagemErroGeral,
    mensagemSucesso: stringsComuns.exameRegistrado,
    mensalmente: 'Mensalmente',
    mesesRetorno: 'Meses para o retorno:',
    modalidade: stringsComuns.modalidade,
    modeloReceita: 'Modelos de receitas de medicamentos',
    modulo: 'Dermatologia',
    morfologia: 'Morfologia',
    morfologiaObrigatoria: stringsComuns.campoObrigatorio,
    motivo: stringsComuns.motivo,
    motivo: stringsComuns.motivo,
    motivoEncaminhamento: stringsComuns.motivoEncaminhamento,
    motivoEncaminhamentoObrigatorio: stringsComuns.campoObrigatorio,
    municipio: stringsComuns.municipio,
    nao: stringsComuns.nao,
    naoAutorizado: 'Não autorizado',
    naoConcordoNemDiscordo: 'Não concordo, nem discordo',
    naoFoiPosisvelCarregarExamesInvalidos: 'Não foi possível carregar os dados de exames inválidos',
    naoFoiPossivelCarregarExamesComLaudo: 'Não foi possível carregar os dados de exames laudados',
    naoFoiPossivelCarregarLaudosEmitidos: 'Não foi possível carregar os dados de laudos emitidos',
    naoFoiPossivelCarregarSemLaudo: 'Não foi possível carregar os dados de exames sem laudo',
    naoFoiPossivelCarregarSemLaudo72h: 'Não foi possível carregar os dados de exames com laudo atrasado',
    naoFoiPossivelCarregarTotais: 'Não foi possível carregar os dados de produtividade',
    naoFoiPossivelLaudosGraves: 'Não foi possível carregar a lista de laudos graves',
    nenhumaLesaoAdicionada: 'Nenhuma lesão adicionada',
    nenhummExameParaLaudo: 'Nenhum exame disponível para laudo',
    nenhumRegistroEncontrado: stringsComuns.nenhumRegistroEncontrado,
    nenhumResultado: stringsComuns.nenhumResultado,
    noaExisteEquipamento: 'A instituição do exame não possui nenhum ponto cadastrado. Entre em contato com os administradores.',
    nome: stringsComuns.nome,
    nomeSistema: stringsComuns.nomeSistema,
    notasAtualizacao: stringsComuns.notasAtualizacao,
    notificacao: 'Notificação',
    novaRede: 'Nova rede',
    numero_exame: 'Número do exame',
    numeroExame: stringsComuns.numeroExame,
    nunca: stringsComuns.nunca,
    nuncaFumou: stringsComuns.nuncaFumou,
    O: 'Outras dermatoses',
    obs: stringsComuns.observacoes,
    observacao: stringsComuns.observacao,
    observacaoTecnica: stringsComuns.observacaoTecnica,
    observacoes: stringsComuns.observacoes,
    observacoesGerais: 'Observações Gerais sobre o uso do(s) medicamento(s).',
    ocupacao: stringsComuns.ocupacao,
    ok: stringsComuns.ok,
    opcoes: 'Opções',
    opiniaoErro: 'Erro ao registrar opinião.',
    opiniaoRegistrada: 'Opinião registrada com sucesso.',
    origem: 'Origem',
    outras: stringsComuns.outras,
    outrasDermatoses: 'Outras dermatoses',
    outrasInfo: stringsComuns.outrasInformacoes,
    outrasInformacoes: 'Outras informações',
    outrasInfosPert: 'Outras informações pertinentes',
    outrosCancer: 'Câncer outros',
    p1: '1 - Possui resultado dos exames físicos, complementares ou laboratoriais?',
    // Pergunta 1
    p1Label: 'O encaminhamento foi realizado conforme protocolo de encaminhamento para consulta especializada de dermatologia?',
    p1Opcao1: 'Regulação estadual conforme aprovados em CIB',
    p1Opcao2: 'Regulação municipal conforme pactuação local',
    p1Opcao3: 'Regulação regional conforme pactuação CIR',
    p1Opcao4: 'Não se aplica',
    p1Opcao5: 'Não sabe',
    p2: '2 - Há confirmação do CID-10 relacionado à lesão?',
    // Pergunta 2
    p2Label: 'Você está satisfeito(a) com o resultado do laudo da Teledermatologia?',
    p2Opcao1: 'Discordo totalmente',
    p2Opcao2: 'Discordo parcialmente',
    p2Opcao3: 'Não concordo, nem discordo',
    p2Opcao4: 'Concordo parcialmente',
    p2Opcao5: 'Concordo totalmente',
    p3: '3 - Informações e orientações apresentadas e negociadas com a pessoa, em relação ao problema em questão.',
    // Pergunta 3
    p3Label: 'Significado dos resultados do exame:',
    p3Opcao1: 'Eu entendi perfeitamente o significado dos resultados dos exames',
    p3Opcao2: 'Eu tive dúvida sobre o significado dos resultados do exames',
    p3Opcao3: 'Eu não entendi o significado do resultado do exame',
    p4: '4 - Estratégias de seguimento longitudinal e continuado da pessoa e do problema em questão e justificativa de novos encaminhamentos.',
    // Pergunta 4
    p4Label: 'Após o resultado do laudo, você tem a intenção de encaminhar o paciente?',
    p4Opcao1: 'Discordo totalmente',
    p4Opcao2: 'Discordo parcialmente',
    p4Opcao3: 'Não concordo, nem discordo',
    p4Opcao4: 'Concordo parcialmente',
    p4Opcao5: 'Concordo totalmente',
    p5: '5 - Utilizar os modelos de receitas de medicamentos?',
    paciente: stringsComuns.paciente,
    pacienteObrigatorio: stringsComuns.pacienteObrigatorio,
    pacs: 'PACS',
    panoramicas: 'Panorâmicas',
    pendencias: stringsComuns.pendencias,
    PERNA_DIREITA_ANTERIOR: 'PERNA_DIREITA_ANTERIOR',
    PERNA_DIREITA_POSTERIOR: 'PERNA_DIREITA_POSTERIOR',
    PERNA_ESQUERDA_ANTERIOR: 'PERNA_ESQUERDA_ANTERIOR',
    PERNA_ESQUERDA_POSTERIOR: 'PERNA_ESQUERDA_POSTERIOR',
    peso: stringsComuns.peso,
    pesquisaExames: 'Pesquisa de exames',
    pesquisaLaudosGraves: 'Pesquisa de laudos graves',
    pesquisar: 'Pesquisar',
    pesquisaSolicitacoesExame: 'Pesquisa de solicitações de exame',
    pessoasMorenas: 'V - Pessoas morenas: raramente se queimam, bronzeiam-se muito',
    pessoasNegras: 'VI - Negros: nunca se queimam, profundamente pigmentados',
    pessoasPeleBranca: 'III - A média das pessoas brancas normais: queimam-se moderadamente, bronzeiam-se gradual e uniformemente',
    pessoasPeleClara: 'IV - Pele clara ou morena clara, cabelos castanho-escuros e olhos escuros: queimam-se muito pouco, bronzeiam-se bastante',
    pessoasPeleClaraRuivas: 'II - Pele clara, olhos azuis, verdes ou castanho-claros, cabelos louros ou ruivos: sempre se queimam e, às vezes, se bronzeiam',
    pessoasPeleClaraSardentas: 'I - Pele clara, olhos azuis, sardentos: sempre se queimam e nunca se bronzeiam',
    posologia: 'Posologia',
    presente: 'Presente (preservada)',
    previewImagem: 'Visualização da imagem',
    priorizandoExame: stringsComuns.priorizandoExame,
    priorizar: stringsComuns.priorizar,
    profissao: stringsComuns.profissao,
    protocolo: stringsComuns.protocolo,
    protocoloCancerPele: 'Protocolo para encaminhamento de pacientes com câncer da pele',
    protocoloMed: 'Protocolo de medicamento',
    proximo: stringsComuns.proximo,
    proximoExame: 'Próximo exame',
    prurido: 'Prurido',
    publicar: 'Publicar',
    qualquerTermo: 'Qualquer um dos termos',
    quatroOuMaisSemana: '4 ou mais vezes por semana',
    receitaMedica: 'Receita médica',
    rede: stringsComuns.rede,
    redeAlterada: 'Rede alterada',
    redeDestino: 'Rede de destino',
    redeOrigem: 'Rede de origem',
    regua: 'Aproximação com régua',
    remover: 'Remover',
    requisicao: stringsComuns.requisicao,
    requisicaoObrigatoria: stringsComuns.campoObrigatorio,
    responsavel: stringsComuns.responsavel,
    responsavelEnvio: stringsComuns.responsavelEnvio,
    resultadoBiopsia: 'Resultado de biópsia (anatomopatológico) da lesão',
    resultadoExames: 'Resultado dos exames',
    resumoLaudo: 'Resumo do laudo',
    sair: stringsComuns.sair,
    salvandoSolicitacao: stringsComuns.salvandoSolicitacao,
    salvar: stringsComuns.salvar,
    selecionar: stringsComuns.selecionar,
    selecionarTodos: 'Selecionar todos',
    semConexao: 'Sem conexão com a internet',
    semInformacao: stringsComuns.semInformacao,
    semLaudo: 'Sem laudo',
    semLaudo72h: 'Atrasado',
    sensibilidadeHanseniase: 'Sensibilidade (em caso de hanseníase)',
    servidorIndisponivel: 'Servidor indisponível ou rede lenta.',
    sexo: stringsComuns.sexo,
    sim: stringsComuns.sim,
    situacao: stringsComuns.situacao,
    situacaoExame: stringsComuns.situacaoExame,
    situacaoLaudo: stringsComuns.situacaoLaudo,
    solicitacao: stringsComuns.solicitacao,
    solicitacaoExame: 'Solicitação de exame',
    solicitacaoRegistrada: 'Solicitação registrada',
    solicitante: stringsComuns.solicitante,
    solicitanteObrigatorio: stringsComuns.campoObrigatorio,
    subcategoria: 'Subcategoria',
    sucesso: stringsComuns.sucesso,
    tabagismo: stringsComuns.tabagismo,
    tabagismoAnosFumoInvalido: stringsComuns.campoInvalido,
    tabagismoAnosFumoObrigatorio: stringsComuns.campoObrigatorio,
    tabagismoCigarrosDiaInvalido: stringsComuns.campoInvalido,
    tabagismoCigarrosDiaObrigatorio: stringsComuns.campoObrigatorio,
    tabagismoObrigatorio: stringsComuns.campoObrigatorio,
    tamanhoCm: stringsComuns.tamanhoCm,
    tamanhoObrigatorio: stringsComuns.campoObrigatorio,
    tecnico: stringsComuns.tecnico,
    teledermatologia: 'Teledermatologia',
    teledermatoscopia: 'Teledermatoscopia',
    tempoDoenca: stringsComuns.tempoDoenca,
    tentarNovamente: stringsComuns.tentarNovamente,
    termoEsclarecimento: stringsComuns.termoEsclarecimento,
    termosDescricao: 'Termos da descrição do exame',
    textoInvalidar: stringsComuns.textoInvalidarExame,
    textoInvalidar: stringsComuns.textoInvalidarExame,
    tipo: 'Tipo',
    tipoContato: 'Tipo de contato',
    tipoDermatose: 'Tipo de dermatose',
    tipoDermatoseObrigatorio: stringsComuns.campoObrigatorio,
    tipoExame: 'Tipo de exame',
    tituloAvaliacao: 'Solicitamos a sua avaliação desse laudo para termos maior controle sobre os resultados dados pelos médicos laudadores.',
    tituloConfirmarEnvioExame: stringsComuns.tituloConfirmarEnvioExame,
    tituloContraReferencia: 'Atendimento ao paciente - Contra-referência',
    tituloEnvioImagens: 'Envio de imagens',
    tituloModalCancelamento: 'Confirmação de cancelamento',
    todasImagens: 'Todas as imagens',
    todosTermos: 'Todos os termos',
    trocandoRede: stringsComuns.trocandoRede,
    trocarRede: 'Trocar rede',
    TRONCO_ANTERIOR: 'TRONCO_ANTERIOR',
    TRONCO_POSTERIOR: 'TRONCO_POSTERIOR',
    troncoAnterior: 'Tronco anterior',
    troncoPosterior: 'Tronco posterior',
    uf: stringsComuns.uf,
    ultrapassouTempoPrevisto: 'Ultrapassou o tempo previsto para laudo',
    valido: 'Válido',
    ver: stringsComuns.ver,
    visualizar: stringsComuns.visualizar,
    voltar: stringsComuns.voltar
};
